import _ from 'lodash';

import detector from 'browser-type-detector';

import { unsupportedBrowsersList } from './dictionary.js';

const browserInfo = detector.getType();

export default class UnsupportedBrowserHelper {

	constructor () {
		this.unsupportedBrowser = this._getUnsupportedBrowser();
	}

	isBrowserUnsupported = () => {
		 
		return this.unsupportedBrowser
			&& ((
				this._checkForMinimalSupportedVersion()
				|| this._checkForMaximalSupportedVersion()
				|| this._checkForSpecificUnsupportedVersion()
			) || this._checkIfNoVersionSpecified());
	}

	_getUnsupportedBrowser = () => {
		return unsupportedBrowsersList.find(browser => browser.name === browserInfo.name);
	}
	/*
	 * Возврат true на любом из методов проверки означает, что браузер не поддерживатся
	*/
	_checkForMinimalSupportedVersion = () => {
		const { minimalSupportedVersion } = this.unsupportedBrowser;

		if (!_.isNil(browserInfo.version) && !_.isNil(minimalSupportedVersion)) {
			return Number(minimalSupportedVersion) > Number(browserInfo.version.name);
		}

		return false;
	}

	_checkForMaximalSupportedVersion = () => {
		const { maximalSupportedVersion } = this.unsupportedBrowser;

		if (!_.isNil(browserInfo.version) && !_.isNil(maximalSupportedVersion)) {
			return Number(maximalSupportedVersion) < Number(browserInfo.version.name);
		}

		return false;
	}

	_checkForSpecificUnsupportedVersion = () => {
		const { specificUnsupportedVersions } = this.unsupportedBrowser;

		if (!_.isNil(browserInfo.version) && !_.isEmpty(specificUnsupportedVersions)) {
			return specificUnsupportedVersions
				.some(version => Number(version) === Number(browserInfo.version.name));
		}

		return false;
	}

	_checkIfNoVersionSpecified = () => {
		return this.unsupportedBrowser && (
			_.isEmpty(this.unsupportedBrowser.specificUnsupportedVersions)
			&& _.isNil(this.unsupportedBrowser.minimalSupportedVersion)
			&& _.isNil(this.unsupportedBrowser.maximalSupportedVersion)
		);
	}
}